export const fetchMUILicense = async (): Promise<string | null> => {
    try {
        const response = await fetch('/api/mui-license');
        if (!response.ok) {
            throw new Error(`Failed to fetch MUI license: ${response.status}`);
        }
        const data = await response.json();
        return data.licenseKey || null;
    } catch (error) {
        console.error('Error fetching MUI license:', error);
        return null;
    }
};
